import React from 'react';

import {Marker} from '@pb/kit-component-table-list';
import foundations from '@pb/kit-styles-primitives/foundations.json';

const STATUS_COLORS: Record<string, string> = {
    DISABLED: foundations.component.indicators['indicator-nagative'],
    ENABLED: foundations.component.indicators['indicator-positive'],
    EMPTY: foundations.icon['icon-grey-heavy'],
    SUSPENDED: foundations.component.indicators['indicator-star'],
};

export const UserStatusMarker = ({statusCode}: {statusCode: string}) => (
    <Marker circle={true} markerColor={STATUS_COLORS[statusCode]} aria-hidden="true"/>
);
